import { connect } from 'react-redux'
import PhotoGalleryComponent from '../components/PhotoGalleryComponent.jsx';
import {
	forwardToExpandMenuMax,
	forwardToMarkPop,
	forwardToFindPhotos,
	forwardToDeletePhotoById
} from '../actions';

const mapStateToProps = (state) => ({
	menu: state.getIn(['menuReducer', 'menu']),
	alert: state.getIn(['checkCardReducer', 'alert']),

	view: state.getIn(['checkCardReducer', 'view']),
	request: state.getIn(['checkCardReducer', 'request']),

	previous: state.getIn(['maintenanceCardsReducer', 'mCardListRequestModel']),
	previousView: state.getIn(['maintenanceCardsReducer', 'mCardListViewModel']),
})

const mapDispatchToProps = (dispatch) => ({

	expandContent: () => {
		dispatch(forwardToExpandMenuMax());
	},
	findPhotos: (card, category) => {
		let type;
		if (0 === category) {
			type = "CLOTH";
		}
		if (1 === category) {
			type = "PANT";
		}
		dispatch(forwardToFindPhotos(card, type, "PRE"));
	},
	pop: (dataUri) => {
		dispatch(forwardToMarkPop(dataUri));
	},
	deletePhotoById: (photoId, card, category, stage) => {
		let type;
		if (0 === category) {
			type = "CLOTH";
		}
		if (1 === category) {
			type = "PANT";
		}
		dispatch(forwardToDeletePhotoById(photoId, card, type, stage));
	},

})

const PhotoGalleryContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(PhotoGalleryComponent)

export default PhotoGalleryContainer;


// WEBPACK FOOTER //
// ./src/containers/PhotoGalleryContainer.jsx